import { Dto, DtoWithId } from "@mango/core";
import { Artikel } from "./artikel";

@Dto({fullName: "CIJBorculo.Logic.ArtikelVerkoopPrijzen"})
export class ArtikelVerkoopPrijzen extends DtoWithId {
	artikel: Artikel;
	prijs: number;
	datum: Date;
}